module.exports = __webpack_public_path__ + "img/ceo-2.5b8d5c17.jpg";